import { Loader, LoaderOptions } from '@googlemaps/js-api-loader'
import { LatLngLiteral } from 'components/Scene'

export const initMap = async ({ startPosition, element }: { startPosition: LatLngLiteral; element: HTMLDivElement }) => {
  const KEY_PARAMS = {
    mapId: 'c28f06d37eb1c13d',
  }

  const screenWith = window.innerWidth

  const mapOptions: google.maps.MapOptions = {
    tilt: 20,
    heading: 0,
    zoom: 18,
    center: startPosition,
    mapTypeId: 'roadmap',
    disableDefaultUI: screenWith < 1000,
    backgroundColor: 'transparent',
    gestureHandling: 'greedy',
    restriction: {
      latLngBounds: {
        north: 58.761749281108676,
        west: 15.462996499390948,
        south: 58.45038108095113,
        east: 17.05424687874114,
      },
    },
    clickableIcons: false,
    minZoom: 12,
    ...KEY_PARAMS,
  }

  const apiOptions: LoaderOptions = {
    apiKey: 'AIzaSyD4fnvux5T5IUju5p8MKMhEtaxKx_BFVo8',
    mapIds: ['c28f06d37eb1c13d'],
    authReferrerPolicy: 'origin',
  }

  const apiLoader = new Loader(apiOptions)
  await apiLoader.load()
  const map = new google.maps.Map(element, mapOptions)

  return map
}
